export const useSubmissionHasUnsupportedFormat = (
  submission: SubmittedDocument
) => {
  if (submission.assignmentType == AssignmentType.general) {
    return false;
  }

  if (
    submission.documentSubmissionType == DocumentSubmissionType.keyWordOutline
  ) {
    return false;
  }

  if (submission.documentSubmissionType == DocumentSubmissionType.roughDraft) {
    var acceptRoughDraftInAnyFormat =
      useAcceptSubmissionRoughDraftInAnyFormat(submission);

    if (acceptRoughDraftInAnyFormat == true) {
      return false;
    }
  }

  if (submission.checklistId == undefined) return false;

  if (submission.fileType == undefined) return false;

  if (submission.fileType == "") return false;

  const supportedFileTypes = [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.google-apps.document",
    "application/msword",
  ] as string[];

  return supportedFileTypes.includes(submission.fileType) != true;
};
